<template>
	<div>
		<div class="actDiv">
			<label style="margin-left:0.625rem ;">小区</label>
			<a-select  style="width:15rem; margin: 0 0.625rem;" v-model="theNeighbor" placeholder="选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search >
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-button   icon="search"  @click="queryData" style="margin-left: 0.5rem;">查询</a-button>
			<a-button   icon="cloud-download"  @click="exportData" style="margin-left: 0.5rem;" :loading="exportLoading">导出</a-button>
			<a-tooltip placement="top" :title="promptText">
				<a-button   icon="cloud-upload"  @click="importData" style="margin-left: 0.5rem;">巡检导入</a-button>
			</a-tooltip>
			<a-button type="primary"   icon="form"  @click="deReadUpdate" style="margin-left: 1.5rem;">扣费读数更新</a-button>
			<a-button :loading="exportWrongLoading" v-if="isFS" type="danger"   icon="warning"  @click="exportWrongMeter" style="margin-left: 1.5rem;">异常表导出</a-button>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="600"   ref="mTable" size="mini"
						  resizable highlight-hover-row :loading="loading">
				<vxe-table-column type="seq" width="60"></vxe-table-column>
				<vxe-table-column title="小区名称" field="NeighborName" width="130"></vxe-table-column>
				<vxe-table-column title="用户号" field="CustomerNum" width="90"></vxe-table-column>
				<vxe-table-column title="用户名" field="CustomerName" width="160"></vxe-table-column>
				<vxe-table-column title="用户地址" field="CustomerAddr" width="180"></vxe-table-column>
				<vxe-table-column title="给水号" field="APID" width="110"></vxe-table-column>
				<vxe-table-column title="集中器" field="GPRSAddr" width="130"></vxe-table-column>
				<vxe-table-column title="采集器地址" field="CollectorAddr" width="130"></vxe-table-column>
				<vxe-table-column title="表地址" field="MeterAddr" width="130"></vxe-table-column>
				<vxe-table-column title="表状态" field="MeterState" width="100" :formatter="getMeterState"></vxe-table-column>
				<vxe-table-column title="表读数" field="readdata" width="120"></vxe-table-column>
				<vxe-table-column title="抄表时间" field="readtime" :formatter="getTimeFormatter"></vxe-table-column>
		</vxe-table>
		<vxe-modal ref="mModal" v-model="showImportFlag" title="巡检导入" width="450" height="350"
								resize destroy-on-close :mask="false" :lock-view="false" :show-zoom="true" :position="{top:250}">
			<a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :disabled="uploading"
							accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
				<a-button type = "default" icon = "upload">选择文件 </a-button>
			</a-upload>
			<a-button icon="cloud-upload" type="primary" :loading="importLoading" :disabled="fileList.length == 0"
							style="margin: 1.25rem 0;" @click="importSubmit">
				开始上传
			</a-button>
		</vxe-modal>
		<vxe-modal ref="dModal" v-model="showDeFlag" title="扣费读数更新" width="450" height="350"
								resize destroy-on-close :mask="false" :lock-view="false" :show-zoom="true" :position="{top:250}">
			<a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :disabled="uploading"
							accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
				<a-button type = "default" icon = "upload">选择文件 </a-button>
			</a-upload>
			<a-button icon="cloud-upload" type="primary" :loading="importLoading" :disabled="fileList.length == 0"
							style="margin: 1.25rem 0;" @click="deReadUpdateSubmit">
				开始上传
			</a-button>
			<div style="font-size: 0.875rem;color: red;">上传的文件第一列为序列号,第二列为要更新的扣费读数</div>
		</vxe-modal>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				isFS:false,
				showDeFlag:false,
				fileList:[],
				neighborList:[],
				dataList:[],
				loading:false,
				theNeighbor:undefined,
				exportLoading:false,
				importLoading:false,
				showImportFlag:false,
				exportWrongLoading:false,
				promptText:"使用方法：在导出的Excel文件的最后一列(现场读数)，填入要修改的读数，保存后再次上传即可.",
			}
		},
		methods:{
			deReadUpdateSubmit(){
				this.importLoading = true;
				const formData = new FormData();
				formData.append('file', this.fileList[0]);
				let url = this.Api.getLastUrl(this.Api.DEREAD_UPDATE_URL);
				this.Api.fetchPostWithFiles(url,formData).then((data)=>{
					this.importLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.showDeFlag = false;
						this.$message.success('更新成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.importLoading = false;
					console.log(error);
				});
			},
			deReadUpdate(){
				this.showDeFlag = true;
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryNeighbors: function() {
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.neighborList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			queryData:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_LIHU_FAIL_METER_DATA_URL);
				let param  = {neighborId:null};
				if(this.theNeighbor !=undefined){
					param.neighborId  = this.theNeighbor.key;
				}
				this.loading = true;
				this.Api.fetchPostWithForm(url,param).then((data) => {
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.dataList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					this.loading = false;
					console.log(error);
				});
			},
			exportData:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_LIHU_FAIL_METER_DATA_EXPORT_URL);
				let param  = {neighborId:null};
				if(this.theNeighbor !=undefined){
					param.neighborId  = this.theNeighbor.key;
				}
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '立户故障表.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			exportWrongMeter(){
				this.exportWrongLoading = true;
				let url = this.Api.getLastUrl(this.Api.EXPORT_WRONG_METER_FS_URL);
				this.Api.fetchPostFile(url).then((res)=>{
					this.exportWrongLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '福山异常表.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportWrongLoading = false;
					console.log(error);
				});
			},
			importData:function(){
				this.showImportFlag = true;
			},
			importSubmit:function(){
				this.importLoading = true;
				const formData = new FormData();
				formData.append('file', this.fileList[0]);
				let url = this.Api.getLastUrl(this.Api.READ_METER_IMPORT_FAILDATA_URL);
				this.Api.fetchPostWithFiles(url,formData).then((data)=>{
					this.importLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						let flag = result['flag'];
						let msgs = result['msg'];
						if(flag){
							this.$message.success(msgs);
							this.showImportFlag = false;
							this.queryData();
						}else{
							this.$message.error(msgs);
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.importLoading = false;
					console.log(error);
				});
			},
			beforeUpload:function(file){
				let flag  = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				if(flag){
					this.fileList = [];
					this.fileList = [...this.fileList, file];
				}else{
					this.$message.error('只能上传Excel文件');
				}
				return false;
			},
			handleRemove:function(file){
				const index = this.fileList.indexOf(file);
				const newFileList = this.fileList.slice();
				newFileList.splice(index, 1);
				this.fileList = newFileList;
			},
		},
		created() {
			this.queryNeighbors();
			this.queryData();
			let wcId = this.Config.getUserLocal().wcId;
			if(wcId == 4){
				this.isFS = true;
			}else{
				this.isFS = true;
			}
		},
	}
</script>

<style>
</style>
